import api from './api';

const JudgingService = {
  // Judge
  getMyAssignments: (round) => api.get('/judging/assignments', { params: { round } }),
  getMyScore: (submissionId, round) => api.get(`/judging/scores/${submissionId}`, { params: { round } }),
  submitScore: (submissionId, data) => api.post(`/judging/scores/${submissionId}`, data),
  saveDraftScore: (submissionId, data) => api.put(`/judging/scores/${submissionId}/draft`, data),

  // Admin
  assignJudge: (data) => api.post('/judging/assign', data),
  bulkAssign: (data) => api.post('/judging/assign/bulk', data),
  getScoresForSubmission: (submissionId, round) => api.get(`/judging/submissions/${submissionId}/scores`, { params: { round } }),
  getAssignmentsForSubmission: (submissionId, round) => api.get(`/judging/submissions/${submissionId}/assignments`, { params: { round } }),
  computeCompositeScores: (data) => api.post('/judging/composite', data),
  getJudgesOverview: (round) => api.get('/judging/judges', { params: { round } }),
};

export default JudgingService;
